/*
 * @Author: 麦勇潮
 * @Date: 2021-01-04 10:56:40
 * @LastEditors: 麦勇潮
 * @LastEditTime: 2021-01-04 14:16:56
 */
import FN from '@/common/fn'

if (FN.isIOS) {
  try {
    // 获取初始用户信息
    let personalMethod = {'method': 'getUserInfo'}
    window.webkit.messageHandlers.GAMESDK.postMessage(personalMethod)
    window.getUserInfo = function (str) {
      let userInfo = str
      FN.saveSession('CLIENT_USER_INFOR', userInfo)
      FN.saveSession('FUSE_CHANNEL_INFO', userInfo.fuse_channel_info)
      FN.saveSession('USER_INFO', userInfo.user_info)
      FN.saveSession('extFooter', userInfo.ext_footer)
      FN.saveSession('INIT_INFO', userInfo.init_info || {hongbao: 0, n_hb: 0}) // 控制红包是否开启
    }
  } catch (error) {
    // 是在web端， h5sdk上slideBar组件post过来
    window.addEventListener('message', event => {
      if (event.data.type === 'getUserInfo') {
        FN.saveSession('CLIENT_USER_INFOR', event.data.data)
        FN.saveSession('FUSE_CHANNEL_INFO', event.data.data.fuse_channel_info)
        FN.saveSession('USER_INFO', event.data.data.user_info)
        FN.saveSession('extFooter', event.data.data.ext_footer)
        FN.saveSession('INIT_INFO', event.data.data.init_info) // 控制红包是否开启
        FN.saveSession('kefu_qq', event.data.data.kefu_qq) // 控制客服q号
      }
    }, false
    )
  }

  try {
    // 获取角色信息
    let personalMethod = {'method': 'getRoleInfo'}
    window.webkit.messageHandlers.GAMESDK.postMessage(personalMethod)
    window.getRoleInfo = function (str) {
      console.log(str)
      let roleBaseMsg = str
      FN.saveSession('ROLE_BASE_MSG', roleBaseMsg)
    }
  } catch (error) {
    // 是在web端
    window.addEventListener(
      'message',
      event => {
        if (event.data.type === 'getRoleInfo') {
          console.log(event.data)
          FN.saveSession('ROLE_BASE_MSG', event.data.roleData)
        }
      },
      false
    )
  }
} else if (FN.isAndroid) {

  try {
    // 获取初始用户信息
    let userInfo = JSON.parse(GAMESDK.getUserInfo())
    FN.saveSession('CLIENT_USER_INFOR', userInfo)
    FN.saveSession('FUSE_CHANNEL_INFO', userInfo.fuse_channel_info)
    FN.saveSession('USER_INFO', userInfo.user_info)
    FN.saveSession('extFooter', userInfo.ext_footer)
    FN.saveSession('INIT_INFO', userInfo.init_info || {hongbao: 0, n_hb: 0}) // 控制红包是否开启
  } catch (error) {
    // 是在web端
    window.addEventListener(
      'message',
      event => {
        console.log(event.data.data)
        if (event.data.type === 'getUserInfo') {
          FN.saveSession('CLIENT_USER_INFOR', event.data.data)
          FN.saveSession('FUSE_CHANNEL_INFO', event.data.data.fuse_channel_info)
          FN.saveSession('USER_INFO', event.data.data.user_info)
          FN.saveSession('extFooter', event.data.data.ext_footer)
          FN.saveSession('INIT_INFO', event.data.data.init_info) // 控制红包是否开启
          FN.saveSession('kefu_qq', event.data.data.kefu_qq) // 控制客服q号
        }
      },
      false
    )
  }

  try {
    // 获取角色信息
    let roleBaseMsg = JSON.parse(GAMESDK.getRoleInfo())
    FN.saveSession('ROLE_BASE_MSG', roleBaseMsg)
  } catch (error) {
    // 是在web端
    window.addEventListener(
      'message',
      event => {
        if (event.data.type === 'getRoleInfo') {
          FN.saveSession('ROLE_BASE_MSG', event.data.roleData)
        }
      },
      false
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/client.js